import { classNames } from '@repo/ui/src/utils/classNames';
import React from 'react';

const COLORS = {
  brand: 'border-brand-300',
  black: 'border-black',
  white: 'border-white',
};

type LoadingColor = keyof typeof COLORS;

export interface LoadingProps {
  className?: string;
  color?: LoadingColor;
}

const Loading = ({ className, color = 'brand' }: LoadingProps) => (
  <div className={classNames('flex justify-center py-4', className || undefined)}>
    <span
      className={`rounded-full w-8 h-8 border-4 ${COLORS[color]} border-r-transparent animate-spin`}
    />
  </div>
);

export default Loading;
